import {useContext, useState} from 'react';
import {
  TwilioClientProvider as ConversationsTwilioClientProvider,
  TwilioClient,
} from '@stripe-internal/twilio-conversations-client';
import type {ClientUrls} from '@stripe-internal/conversations-client';
import {ConfigContext} from '../ConfigProvider';
import {useObservability} from '../ObservabilityProvider';
import {useApi} from '../ApiProvider/ApiProvider';
import {isDotComEntryPoint} from '../../Screens/ChatScreen/conversationUtils';

type Props = {
  children: JSX.Element;
};

export const TwilioClientProvider = ({children}: Props) => {
  const observability = useObservability();
  const {
    audience,
    entrypoint: entryPoint,
    stripeThirdPartyBaseUrl,
  } = useContext(ConfigContext);
  const api = useApi();

  const humanAgentGroup = isDotComEntryPoint(entryPoint) ? 'sales' : 'support';

  const urls: Partial<ClientUrls> = {
    tokenUrl: `/api/chat-token?audience=${audience}&entrypoint=${entryPoint}`,
    conversationUrl: `/api/start-chat?audience=${audience}&entrypoint=${entryPoint}&human_agent_group=${humanAgentGroup}`,
  };

  const [client] = useState(
    () => new TwilioClient({clientFetch: api.fetch, urls, observability}),
  );

  return (
    <ConversationsTwilioClientProvider
      value={client}
      observability={observability}
      urls={urls}
      baseURL={stripeThirdPartyBaseUrl}
    >
      {children}
    </ConversationsTwilioClientProvider>
  );
};
